<template>
    <md-layout md-row class="ql-project-search">
        <!-- <p>Search Coming Soon</p> -->
<!--         <md-button class="md-icon-button ql-search-button" @click="visible = !visible">
            <md-icon>search</md-icon>
        </md-button>
        <md-layout md-gutter v-if="visible">
            <form novalidate @submit.stop.prevent="submit">
                <md-input-container>
                    <label>Search</label>
                    <md-autocomplete v-model="searchPageChoice"
                        :list="searchResults"
                        print-attribute="resultComposite"
                        :filter-list="search"
                        :min-chars="0"
                        :max-height="6"
                        @selected="selectSearchResult"
                        :debounce="500"
                        width="100%">
                    </md-autocomplete>
                </md-input-container>
            </form>
        </md-layout> -->
    </md-layout>
</template>

<script>
import NavBus from '@/buses/nav';

const ProjectSearch = {
    resultComposite: 'projectSearch',
    data: function() {
        return {
            visible: false,
            searchPageChoice: '',
            searchResults: [
                {term: 'legend', page: 1, resultComposite: 'Page 1: legend'},
                {term: 'legend', page: 2, resultComposite: 'Page 2: legend'},
                {term: 'characters', page: 2, resultComposite: 'Page 2: characters'},
                {term: 'pre-show', page: 3, resultComposite: 'Page 3: pre-show'},
                {term: 'eddie', page: 2, resultComposite: 'Page 2: eddie'},
                {term: 'eddie', page: 3, resultComposite: 'Page 3: eddie'}
            ]
        };
    },
    methods: {
        search: function(list, query) {
            const arr = [];

            for (let i = 0; i < list.length; i++) {
                if (list[i].term.indexOf(query.toLowerCase()) !== -1) {
                    arr.push(list[i]);
                }

                if (arr.length > 5) {
                    break;
                }
            }

            return arr;
        },
        selectSearchResult: function(item) {
            NavBus.$emit('goToPage', item.page);
        }
    }
};

export default ProjectSearch;
</script>

<style lang="scss">
.ql-project-search {
    position: absolute;
    max-width: 30%;
    right: 20px;
}
.md-autocomplete-content {
    background: white;
    opacity: 1;
}
</style>


// WEBPACK FOOTER //
// search.vue?73ece769